import {questions} from '../../lib/words'
import { MAX_CHALLENGES } from '../../constants/settings'
import { Hint } from './hint'
type Props = {
  guesses: string[]
  isGameWon?: boolean
}

export const Hints = ({
  guesses,
  isGameWon
}: Props) => {

  var guessesToQuestions = new Array<string>();
  var guessesToQuestions2 = new Array<string>();
  var i =0
  var guessIndex = new Array<number>();
  var guessIndex2 = new Array<number>();
  if (!isGameWon &&guesses.length!==MAX_CHALLENGES )
  {
    for (i =0; i<guesses.length; i++){
      guessesToQuestions.push(questions[i])
      guessIndex.push(i)
    }
    guessesToQuestions2.push(questions[i])
    guessIndex2.push(i)

  }
  else { //if game is done show all hints, but so last used clue in green

      for (i =0; i<MAX_CHALLENGES-1; i++){
        guessesToQuestions.push(questions[i])
        guessIndex.push(i)
      }
      guessesToQuestions2.push(questions[i])
      guessIndex2.push(i)
  }
  // for (i; i<MAX_CHALLENGES; i++){
  //   guessesToQuestions2.push("")
  // }


  return (
    <div className="scroll-container grow" id="hints-box">
        {guessIndex.map((key) => (
          <Hint
            key={key}
            value={guessesToQuestions[key]}
            //classes={classes}//{"text-m leading-4 font-medium text-gray-900 dark:text-gray-100 flex flex-col mt-1 divide-y"}
            isLast={false}//{key === guesses.length}
            isClueThatWon={(key === guesses.length-1 && isGameWon)}
            isGameWon={isGameWon}
          />
        ))}
        {guessIndex2.map((key) => (
          <Hint
            key={key}
            value={guessesToQuestions2[key-(guessIndex.length)]}
            //classes={classes}//{"text-m leading-4 font-medium text-yellow-500 flex flex-col mt-1 divide-y"}
            isLast={true}//{key === guesses.length}
            isClueThatWon={(key === guesses.length-1 && isGameWon)}//{(key === guesses.length-1  && isGameWon)}
            isGameWon={isGameWon}
          />
        ))}
    </div>
  )
}
